import React, { useCallback, useEffect, useState } from 'react';
import { getSaglik } from '../services/reklamApi';
import AiOneriler from './reklam/AiOneriler';
import Kararlar from './reklam/Kararlar';
import Yarat from './reklam/Yarat';
import Ayarlar from './reklam/Ayarlar';
import DonemAnalizi from './reklam/DonemAnalizi';
// OnayKuyrugu sekmesi 2026-10-01'de kaldirildi (tek motor karari) — dosya duruyor.
// eslint-disable-next-line no-unused-vars
import OnayKuyrugu from './reklam/OnayKuyrugu';
import Sablonlar from './reklam/Sablonlar';
import Yapi from './reklam/Yapi';

// Reklam Yönetimi artık ALT SEKMELİ bir çerçeve — kullanıcı talebi: 2026-08-12 ("ileride
// başka alt ekranlar da gelecek, bildirimler onaylar vs — şimdiden güzel bir alt menü
// tasarlasak"). Her sekmenin kendi dosyası var (./reklam/*.js), yeni bir sekme eklemek için
// SEKMELER dizisine bir satır + ilgili component import'u eklemek yeterli. Ayrı route
// açmadık (React Router nested route) — bu iç bir yönetim aracı, sekme durumu URL'de
// tutulmasa da sorun olmaz, basit React state yeterli.
// Sekme adlari 2026-08-16/17'de kullanici talebiyle yeniden adlandirildi. Son ad seti, iki
// ekranin SAHIPLIGINI net ayirmak icin secildi (kullanici: "taslar yerine otursun"):
//   "Kullanıcı Analizi"   — metriklere KULLANICI karar verir, serbest donem, oneri uretilmez
//   "Yapay Zeka Analizi"  — metriklere ve esiklere SISTEM karar verir, oneriyi sistem uretir
//   "Yapay Zeka Önerileri"         — uretilen tum oneriler + icerik teslim/geri alma kanali
// "Uyarılar" sekmesi KALDIRILDI (2026-08-19): 2026-08-12'de yer tutucu olarak açılmıştı,
// içi hiç doldurulmadı. Gerçek sistem uyarıları zaten bu sayfanın EN ÜSTÜNDE şerit olarak
// gösteriliyor (SistemUyari tablosu, /api/saglik). Dosya duruyor; işlevi olursa geri eklenir.
const SEKMELER = [
  // KARARLAR en basta (kullanici talebi: 2026-09-29): kullanici "ben ne isteyecegimi bilecek
  // kadar bilmiyorum" dedi — ekrani acinca ilk gordugu sey, okuyup kabul/red edecegi kararlar
  // olmali. Onceki "Yapay Zeka Onerileri" sekmesi karar onayi ile video uretim studyosunu ayni
  // yerde topluyordu; studyo orada kaldi, KARAR buraya ayrildi.
  { anahtar: 'kararlar', etiket: '⚖️ Kararlar', bilesen: Kararlar },
  { anahtar: 'kullanici-analizi', etiket: 'Kullanıcı Analizi', bilesen: DonemAnalizi },
  // "Yapay Zeka Analizi" (OnayKuyrugu) SEKMESİ KALDIRILDI — kullanıcı kararı: 2026-10-01.
  //
  // NEDEN: aynı anda ÜÇ ayrı motor aynı tabloya (ReklamKararlar) karar yazıyordu —
  // bu ekran (ağacın kendi kuralı), KARARLAR ekranı (OneriUreticisi) ve Pazartesi otomatik
  // taraması. Üçünün kuralları farklıydı; biri "durdur" derken diğeri "dokunma" diyebiliyordu.
  // 2026-08-17'de aynı ders bir kez alınmıştı ("iki motor çalışsaydı biri kapat diğeri koru
  // derdi"), o zaman iki motor vardı, bu gece üç olduğu görüldü.
  //
  // Özellikle kritikti: 30.09 gecesi konan "bir şubede bir alanda reklamsız kalmak EN KÖTÜ
  // KARARDIR" koruması yalnızca OneriUreticisi'nde vardı. Diğer iki yol o korumayı delip
  // "PasifeAl" kartı üretebiliyordu.
  //
  // Artık TEK motor var: KARARLAR ekranı. Bileşen dosyası (OnayKuyrugu.js) silinmedi —
  // geçmiş kararlar ona referans veriyor, gerekirse geri açılabilir.
  { anahtar: 'ai-oneriler', etiket: 'İçerik Stüdyosu', bilesen: AiOneriler },
  { anahtar: 'ayarlar', etiket: 'Ayarlar', bilesen: Ayarlar },
  // Creatomate sablonlari: tasarimi insan yapar, sistem alanlari doldurur (2026-08-24).
  { anahtar: 'sablonlar', etiket: 'Şablonlar', bilesen: Sablonlar },
  // Kampanya/set/reklam agaci + klonlama (kullanici talebi: 2026-09-06): yeni set acmak icin
  // Meta paneline gitmeye gerek kalmasin.
  { anahtar: 'yapi', etiket: 'Hesap Yapısı', bilesen: Yapi },
  // Yeni kampanya / yeni reklam seti sihirbazi (kullanici talebi: 2026-09-29): calisan bir
  // referans setten kopyalar, kullaniciya yalniz degiseni sorar, DURDURULMUS olusturur.
  { anahtar: 'yarat', etiket: '✨ Yarat', bilesen: Yarat },
];

export default function ReklamYonetimi() {
  const [durum, setDurum] = useState('yukleniyor'); // yukleniyor | bagli | hata
  const [hataMesaji, setHataMesaji] = useState('');
  // Açık sistem uyarıları — kullanıcı talebi: 2026-08-18. 2026-08-15'te lead akışı 15 saat
  // durduğunda bunu sistem değil kullanıcı fark etmişti; çalışan bir alarm yoktu.
  const [uyarilar, setUyarilar] = useState([]);
  const [aktifSekme, setAktifSekme] = useState(SEKMELER[0].anahtar);

  // Bağlantı kontrolü tüm modülün sağlığına ait, tek bir sekmeye değil — FizyofiAdsAPI
  // çökükse hiçbir sekme çalışmaz. Ama kullanıcı talebi (2026-08-12): "Performans kaydı: 22,
  // Reklam kararı: 0" gibi iç detaylar patronu ilgilendirmiyor — bu yüzden her şey yolundaysa
  // HİÇBİR ŞEY göstermiyoruz, sadece gerçek bir sorun olduğunda görünür oluyor.
  // sessiz = arka plan tazelemesi. Kullanıcı şikâyeti (2026-08-19): "ekran periyodik olarak
  // kendini yeniliyor, ben üstünde çalışırken yenilemeye denk gelince baştan başlıyorum".
  // Sebep: her tazelemede durum 'yukleniyor' oluyordu, o anda aktif sekme EKRANDAN KALKIYOR
  // ve React bileşeni sıfırdan kuruyordu — yazılan notlar, onaylar, yüklemeler uçuyordu.
  // Artık yalnızca İLK açılışta "Bağlanılıyor" gösteriliyor; arka plan turu sessiz.
  const baglantiKontrolEt = useCallback((sessiz = false) => {
    if (!sessiz) setDurum('yukleniyor');
    getSaglik()
      .then(r => { setDurum('bagli'); setUyarilar(r.data?.uyarilar || []); })
      .catch(err => {
        setHataMesaji(err.message || 'Bilinmeyen hata');
        setDurum('hata');
      });
  }, []);

  // PERİYODİK YENİLEME KALDIRILDI (kullanıcı talebi: 2026-08-21).
  // Amacı sistem alarmlarını ekran açıkken yakalamaktı. Ama kullanıcı kreatif metinlerini
  // dakikalarca inceliyor ve tazeleme sırasında yazdıklarını kaybediyordu — kazandırdığından
  // fazlasını götüren bir özellikti. Alarm zaten veritabanında duruyor; ekrana her girişte
  // ve "uyarıları yenile" düğmesiyle görünür.
  useEffect(() => { baglantiKontrolEt(); }, [baglantiKontrolEt]);

  const AktifBilesen = SEKMELER.find(s => s.anahtar === aktifSekme)?.bilesen;

  return (
    <div>
      <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>📢 Reklam Yönetimi</h2>

      {durum === 'hata' && (
        <div style={{
          background: '#FFF6E5', border: '1px solid #E8C468', borderRadius: 8,
          padding: 12, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <span style={{ color: '#D9534F', fontWeight: 600, fontSize: 13 }}>● Reklam sistemine bağlanılamadı</span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{hataMesaji}</span>
          <button onClick={baglantiKontrolEt} style={{
            marginLeft: 'auto', border: '1px solid var(--border)', background: '#fff',
            borderRadius: 6, padding: '4px 10px', fontSize: 12, cursor: 'pointer',
          }}>Tekrar Dene</button>
        </div>
      )}

      {/* SİSTEM UYARILARI — yalnızca gerçek bir sorun varsa görünür. Her şey yolundaysa
          hiçbir şey gösterilmez (kullanıcı kuralı: iç detaylar patronu ilgilendirmiyor). */}
      {uyarilar.map(u => (
        <div key={u.id} style={{
          background: u.seviye === 'Kritik' ? '#FDECEA' : '#FFF6E5',
          border: `1px solid ${u.seviye === 'Kritik' ? '#E6A9A2' : '#E8C468'}`,
          borderRadius: 8, padding: 12, marginBottom: 12,
          display: 'flex', alignItems: 'flex-start', gap: 12,
        }}>
          <span style={{ fontSize: 16 }}>{u.seviye === 'Kritik' ? '🔴' : '🟡'}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: u.seviye === 'Kritik' ? '#C0392B' : '#8A6D1F' }}>
              {u.baslik}
            </div>
            {u.mesaj && <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{u.mesaj}</div>}
            <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
              Başlangıç: {new Date(u.olusmaZamani).toLocaleString('tr-TR')}
            </div>
          </div>
        </div>
      ))}

      {/* Alt sekme çubuğu */}      <div style={{ display: 'flex', gap: 4, borderBottom: '2px solid var(--border)', marginBottom: 20, alignItems: 'center' }}>
        {SEKMELER.map(s => (
          <button key={s.anahtar} onClick={() => setAktifSekme(s.anahtar)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            padding: '10px 16px', fontSize: 13, fontWeight: 600,
            color: aktifSekme === s.anahtar ? '#1D9E75' : 'var(--text-muted)',
            borderBottom: aktifSekme === s.anahtar ? '2px solid #1D9E75' : '2px solid transparent',
            marginBottom: -2,
          }}>
            {s.etiket}
          </button>
        ))}
        {/* Alarmları elle sorma — otomatik tazeleme kaldırıldığı için (2026-08-21). */}
        <button onClick={() => baglantiKontrolEt(true)}
          title="Sistem uyarılarını yeniden sorar; ekrandaki işinizi bozmaz"
          style={{
            marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer',
            fontSize: 11.5, color: 'var(--text-muted)', textDecoration: 'underline', padding: '6px 8px',
          }}>uyarıları yenile</button>
      </div>

      {durum === 'yukleniyor' ? (
        <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>⏳ Bağlanılıyor...</div>
      ) : (
        AktifBilesen && <AktifBilesen />
      )}
    </div>
  );
}
